import React from 'react';
import MainContent from './MainContent';

import DocNav from './DocNav';
import Dashboard from '../Dashboard';

const Patients = () => {
    return ( 
        <div>
    <div class="min-h-screen flex flex-col flex-auto flex-shrink-0 antialiased bg-green-50  text-black ">

      {/* Navigation Here */}
      <DocNav />
    
      
      <div  class="h-full ml-14 mt-14 mb-10 md:ml-64">
          {/* Main content here */}
      {/* <MainContent /> */}
      <Dashboard />

      </div>
      
    </div>
  </div>    

  
     );
}
 
export default Patients;